/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      _this.element = $( '.events-grid' );
      _this.submit = $( '.event-filter-submit' );
      _this.loading = $( '.events-grid-wrapper' );
      _this.announce = $( '.even-announce' );
      _this.date = _this.getFormattedTodayDate();
      _this.category = false;
      _this.running = false;

      $( '.featured-events-slider__wrapper.splide' ).each( function( index, slide ) {
        const splide = new Splide( slide, {
          type: 'slide',
          perPage: 1,
          perMove: 1,
          gap: '1rem',
          pagination: false,
          drag: false,
          live: true,
        } );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
          };
        } );

        splide.on( 'visible', function( e ) {
          $( e.slide ).find( '.splide-slide' ).attr( 'tabindex', '0' );
        } );

        splide.on( 'hidden', function( e ) {
          $( e.slide ).find( '.splide-slide' ).removeAttr( 'tabindex' );
        } );

        splide.mount();
      } );

      if ( _this.element ) {
        $( document ).on( 'submit', '.js-events-filter-form', function( event ) {
          event.preventDefault();
          // stop if its currently running
          if ( _this.running ) {
            return false;
          }

          _this.running = true;
          const formData = new FormData( this );

          for ( const [key, value] of formData.entries() ) {
            if ( key === 'category' ) {
              _this.category = value === 'all' ? false : {'term_id': value};
            } else {
              if ( !_this.checkDate( value ) ) {
                console.log( 'it did not pass' );
                _this.running = false;
                return false;
              }
              _this.date = value.split( '/' );
              _this.date = _this.date[2] + '-' + _this.date[0] + '-' + _this.date[1];
            }
          }
          _this.filter( _this.category, _this.date );

          return false;
        } );
      }

      // load the events on page load
      _this.submit.prop( 'disabled', true );
      _this.running = true;
      _this.filter( _this.category, _this.date );
    },
    checkDate: function( date ) {
      const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
      if ( !dateRegex.test( date ) ) {
        $( '.date-error' ).text( 'Please enter a valid date in MM/DD/YYYY format.' ).show();
        $( '.date-error' ).addClass( 'has-error' );
        return false;
      }


      // Split and convert to numbers
      const parts = date.split( '/' );
      const month = parseInt( parts[0], 10 );
      const day = parseInt( parts[1], 10 );
      const year = parseInt( parts[2], 10 );
      const inputDate = new Date( year, month - 1, day );
      const today = new Date();
      today.setHours( 0, 0, 0, 0 ); // normalize to midnight for accurate compare
      inputDate.setHours( 0, 0, 0, 0 ); // clear time too

      // Create the date object
      const testDate = new Date( year, month - 1, day );

      // Check if the date object components match input
      const isValidDate =
            testDate.getFullYear() === year &&
            testDate.getMonth() === month - 1 &&
            testDate.getDate() === day;

      // check if its a valid date
      if ( !isValidDate ) {
        $( '.date-error' ).text( 'That date does not exist.' ).show();
        $( '.date-error' ).addClass( 'has-error' );
        return false;
      }
      // check if its a past date
      if ( inputDate.getTime() < today.getTime() ) {
        $( '.date-error' ).text( 'The date cannot be in the past.' ).show();
        $( '.date-error' ).addClass( 'has-error' );
        return false;
      }

      // Passed all checks
      $( '.date-error' ).hide();
      $( '.date-error' ).removeClass( 'has-error' );
      return true;
    },
    getFormattedTodayDate: function() {
      const today = new Date();

      const year = today.getFullYear();
      const day = String( today.getDate() ).padStart( 2, '0' );
      const month = String( today.getMonth() + 1 ).padStart( 2, '0' ); // Month is 0-indexed

      return `${year}-${month}-${day}`;
    },
    filter: function( category, date ) {
      const _this = this;
      $.ajax( {
        type: 'POST',
        url: site_info.ajax_url,
        dataType: 'html',
        data: {
          action: 'll_run_function',
          function: 'get_events_by_category_and_date',
          params: {
            category: category,
            date: date,
            is_vue: false,
          },
        },
        beforeSend: function( xhr ) {
          _this.loading.addClass( 'is-loading' );
        },
        success: function( data ) {
          data = $.parseJSON( data );
          _this.loading.removeClass( 'is-loading' );
          const locationText = _this.location ? _this.location : 'any location';
          _this.announce.text( 'Events at ' + locationText + ' on '+ _this.date );
          _this.element.html( data.response );
        },
        complete: function( jqXHR, status ) {
          _this.running = false;
          _this.submit.prop( 'disabled', false );
        },
        error: function( xhr, status, error ) {
          console.error( 'AJAX error:', error );
        },
      } );
    },

    finalize: function() {
    },
  };
  app.registerComponent( 'event', COMPONENT );
} )( app );
